import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable} from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import {
    QuartelActionTypes,
    QuartelAdd,
    QuartelAdded,
    QuartelAllLoaded,
    QuartelDelete,
    QuartelDeleted,
    QuartelEdit,
    QuartelEdited,
    QuartelGetAll,
    QuartelGetPage,
    QuartelPageLoaded,
} from '../_actions/quartel.actions';
import { QuartelService } from '../_services/quartel.service';


@Injectable()
export class QuartelEffects {

    constructor(
        private actions: Actions,
        private quartelService: QuartelService,
        private router: Router,
    ) {}

    @Effect()
    add: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_ADD),
        map((action: QuartelAdd) => action.payload),
        switchMap(payload => {
            return this.quartelService.add(payload.quartel).pipe(
                map((quartelId)=>{ //Adecuarse a la response recibida de api real
                    //console.log("add quartel");
                    //console.log(JSON.stringify(payload.quartel));
                    let quartel = {
                        ...payload.quartel,
                        id: quartelId
                    };
                    return new QuartelAdded({quartel: quartel});
                })
            );
        })  
    );

    @Effect()
    edit: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_EDIT),
        map((action: QuartelEdit) => action.payload),
        switchMap(payload => {
            return this.quartelService.edit(payload.quartel).pipe(
                map((response)=>{ //Adecuarse a la response recibida de api real
                    //console.log("edit quartel");
                    //console.log(JSON.stringify(payload.quartel));
                    return new QuartelEdited({partialQuartel: payload.quartel, quartel:payload.quartel});
                })
            );
        })  
    );

    @Effect()
    delete: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_DELETE),
        map((action: QuartelDelete) => action.payload),
        switchMap(payload => {
            return this.quartelService.delete(payload.quartel).pipe(
                map((response)=>{ //Adecuarse a la response recibida de api real
                    //console.log("delete quartel");
                    //console.log(JSON.stringify(payload.quartel));
                    return new QuartelDeleted({id: payload.quartel.id});
                })
            );
        })  
    );

    @Effect()
    getPage: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_GET_PAGE),
        map((action: QuartelGetPage) => action.payload),
        switchMap(payload => {
            return this.quartelService.getPage(payload.page).pipe(
                map((response)=>{ //Adecuarse a la response recibida de api real
                    //console.log("get page quartel");
                    //console.log(JSON.stringify(payload.quartel));
                    return {quartels: response.items, page: payload.page, totalCount: response.totalCount};
                })
            );
        }),
        map((response)=>{
            return new QuartelPageLoaded(response);
        })
    );

    @Effect()
    getAll: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_GET_ALL),
        map((action: QuartelGetAll) => action.payload),
        switchMap(payload => {            
            return this.quartelService.getAll().pipe(
                map((quartels)=>{ //Adecuarse a la response recibida de api real
                    //console.log("get all quartels");
                    //console.log(JSON.stringify(quartels));
                    return quartels
                })
            );
        }),
        map((quartels)=>{
            return new QuartelAllLoaded({quartels: quartels});
        })
    );

    @Effect({dispatch:false})
    pageLoaded: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_PAGE_LOADED),
        //tap((action:QuartelPageLoaded)=>console.log("quartel page loaded"))
    );

    @Effect({dispatch:false})
    allLoaded: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_ALL_LOADED),
        //tap((action:QuartelAllLoaded)=>console.log("quartel all loaded"))
    );

    @Effect({dispatch:false})
    added: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_ADDED),
        //tap((action:QuartelAdded)=>console.log("quartel added"))
    );

    @Effect({dispatch:false})
    edited: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_EDITED),
        //tap((action:QuartelEdited)=>console.log("quartel edited"))
    );

    @Effect({dispatch:false})
    deleted: Observable<any> = this.actions.pipe(
        ofType(QuartelActionTypes.QUARTEL_DELETED),
        //tap((action:QuartelDeleted)=>console.log("quartel deleted"))
    );
}